import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../../services/brdsql.service';
import { FileUpload } from 'src/app/model/file-upload.model';
import { FileUploadService } from 'src/app/services/file-upload.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-emp-add',
  templateUrl: './emp-add.component.html',
  styleUrls: ['./emp-add.component.css']
})
export class EmpAddComponent implements OnInit {

  departmentData?: any = [];
  empData?: any = [];
  jobtitleData?: any = [];
  fileName = 'ExcelDownload.xlsx';
  @ViewChild('tb_data') tb_data!: ElementRef;
  @ViewChild('frm_addEmp') mytemplateForm : NgForm;
  formEdit = false;
  empEdit?: any = [];
  // about upload file
  selectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  percentage = 0;
  urlImg = "";
  imgInModal = ""

  constructor(
    private brdservice: BrdsqlService,
    private uploadService: FileUploadService,
  ) { }

  ngOnInit(): void {
    this.departmentList();
    this.empList();
    this.jobList();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async departmentList() {
    await this.brdservice.departmentList()
      .subscribe({
        next: (data: any) => {
          this.departmentData = data.recordset;
          // console.log('department data: ', this.departmentData);
        }
      })
  }

  async empList() {
    this.empData = [];
    await this.brdservice.employeeList()
      .subscribe({
        next: (data: any) => {
          this.empData = data.recordset;
          // console.log('empList : ', this.empData);
          setTimeout(() => {
            $(this.tb_data.nativeElement).DataTable();
          }, 0);
        }
      })
  }

  async jobList() {
    await this.brdservice.jobtitleList()
      .subscribe({
        next: (data: any) => {
          this.jobtitleData = data.recordset;
          console.log('job data: ', this.jobtitleData);
        }
      })
  }

  exportEmp(): void {
    {
      /* table id is passed over here */
      let element = document.getElementById('emp-table');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, this.fileName);

    }
  }

  editEmp(dataid: string) {
    this.formEdit = true;  // สถานะเป็นฟอร์มแก้ไข
    this.empEdit = this.empData.filter((el: { dataid: any; }) => el.dataid == dataid);
    this.empEdit = this.empEdit[0];
    // console.log('empEdit ' ,this.empEdit);
  }

  // select file to upload from audit
  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }

  // upload photo from audit
  upload(): void {
    // this.supcode = localStorage.getItem('supcode');
    // console.log('supcode upload method in audit list :' ,this.supcode);
    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);
      this.selectedFiles = undefined;
      if (file) {
        this.currentFileUpload = new FileUpload(file);
        this.uploadService.pushFileToStorage(this.currentFileUpload).subscribe(
          percentage => {
            this.percentage = Math.round(percentage ? percentage : 0);
            let bucket = 'brr-farmluck.appspot.com'
            let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/empPic/' + file.name;
            console.log(url_pubilc);
            this.urlImg = url_pubilc;
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }

  // บันทึกฟอร์มเพิ่มข้อมูลพนักงาน
  saveAddEmp(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveAddBrdEmp(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                // this.refreshCheck();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
      // บันทึกแล้วรีเฟรซข้อมูล
      // this.router.navigateByUrl('/ListComponent', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/editplotmanager']);
      // });

    })
  };

  // บันทึกการแก้ไขข้อมูลพนักงาน
  saveEditEmp(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.updateDepartment(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.empList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  // ลบข้อมูลพนักงาน 
  delEmp(dataid: string) {
    // console.log('dataid: ' ,dataid)
    Swal.fire({
      title: 'ยืนยันการลบข้อมูล?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.delEmp(dataid)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.empList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการลบข้อมูล',
          'cancle'
        )
      }
    })
  }

  openModalEmp(id:any ,imgurl:any){
    // this.titletext = "ตรวจสอบสินเชื่อแปลง";
    this.imgInModal = imgurl;
    $("#md_empPic").modal('show');
    // this.oneselect = this.zonelist.filter(el => el.edit_ID === id);
    // console.log(this.oneselect);
  }

  closModalEmp(){
    $("#md_empPic").modal('hide');
  }

  setFormDefault() {
    this.formEdit = false;
  }

  resetFormAddemp() {
    this.mytemplateForm.reset()
    this.formEdit = false;
  }

}